class PrintOrdersController {
    /*@ngInject*/
    constructor($timeout, AtmResidualService, $translate) {
        this.$timeout = $timeout;
        this.AtmResidualService = AtmResidualService;
        this.$translate = $translate;
        this.results = [];
        this.loading = false;
        this.tabLabel = '';
    }

    $onInit() {
        let printData = undefined;
        if (window.opener && window.opener.w && window.opener.w.printData) {
            printData = window.opener.w.printData;
            this.branch = printData.branch;
            this.startDate = printData.startDate;
            this.endDate = printData.endDate;
            this.fundingSourceId = printData.fundingSourceId;
            this.fundingSourceKey = printData.fundingSourceKey;
            this.customerId = printData.customerId;
            this.search = printData.search;
            this.currencyFilter = printData.currencyFilter;
            this.tab = printData.tab;
            this.tabLabel = this.formatTabLabel(this.tab);
            this.totalCount = printData.totalCount;
        }

        if (!this.tab) return;

        const currencyId = this.currencyFilter === 'ALL' ? null : this.currencyFilter;
        let fetchPromise;

        if (this.tab === 'inProcess') {
            fetchPromise = this.AtmResidualService.shipmentInProcess(this.branch, this.startDate, this.endDate, this.fundingSourceId, this.customerId, this.search, 0, this.totalCount || 10000, currencyId)
                .then(data => {
                    this.results = data.results;
                });
        } else if (this.tab === 'completed') {
            fetchPromise = this.AtmResidualService.orderHistory(this.branch, this.startDate, this.endDate, this.fundingSourceId, this.customerId, this.search, 0, this.totalCount || 10000, currencyId)
                .then(data => {
                    this.results = data.completedShipment;
                });
        } else if (this.tab === 'pending') {
            fetchPromise = this.AtmResidualService.unpackedShipmentList(this.branch, this.startDate, this.endDate, this.fundingSourceId, this.customerId, this.search, this.totalCount || 10000, 0, currencyId)
                .then(data => {
                    this.results = data.results;
                });
        } else if (this.tab === 'errors') {
            var errStartDate = moment(this.startDate).format('YYYY/MM/DD');
            var errEndDate = moment(this.endDate).format('YYYY/MM/DD');
            fetchPromise = this.AtmResidualService.errorShipmentList(this.branch, this.fundingSourceId, errStartDate, errEndDate, this.search, 0, this.totalCount || 10000, currencyId)
                .then(data => {
                    this.results = data.errorShipment;
                });
        }

        if (fetchPromise) {
            this.loading = true;
            fetchPromise
                .then(() => {
                    this.$timeout(() => {
                        window.print();
                    }, 1000);
                })
                .catch(err => {
                    console.error(err);
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }

    formatTabLabel(tab) {
        switch (tab) {
            case 'inProcess':
                return 'IN PROCESS';
            case 'completed':
                return 'COMPLETED';
            case 'pending':
                return 'PENDING';
            case 'errors':
                return 'ERRORS';
        default:
            return '';
        }
    }
}

PrintOrdersController.$inject = ['$timeout', 'AtmResidualService', '$translate'];

export default PrintOrdersController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/orders/print/print.controller.js